// import { Banner } from '@apis/index'
// import Button from '@components/button'
// import Fields from '@components/fields'
// import Grid from '@components/grid'
// import Row from '@components/row'
// import Wrapper from '@components/wrapper'
// import { outlineButton } from '@pages/admin/payment/settings/form'
// import { RootState } from '@store/index'
// import { Form, Formik } from 'formik'
// import React, { Fragment, useEffect, useState } from 'react'
// import { useSelector } from 'react-redux'
// import { useLocation, useNavigate } from 'react-router-dom'

// const BannerForm = () => {
//   const navigate = useNavigate()
//   const { state } = useLocation()
//   console.log({ state })
//   const [initialValues, setInitialValues] = useState({
//     link: '',
//     image: '',
//   })
//   useEffect(() => {
//     if (!!state) {
//       setInitialValues({
//         link: state.link,
//         image: state.image,
//       })
//     } else {
//       setInitialValues({
//         link: '',
//         image: '',
//       })
//     }
//   }, [state])
//   const handleSubmit = async (values, { resetForm }) => {
//     try {
//       const payload = {
//         link: values.link,
//         image:
//           typeof values.image === 'string'
//             ? values.image
//             : {
//                 extension: values.image.extension,
//                 base64: values.image.base64,
//               },
//       }
//       console.log(payload)
//       if (!!state) {
//         await Banner.update({
//           state: 'banners',
//           id: state.id,
//           data: JSON.stringify(payload),
//         })
//         navigate('/admin/banner-settings', { state: null })
//         resetForm()
//       } else {
//         await Banner.create({
//           state: 'banners',
//           data: JSON.stringify(payload),
//         })
//         resetForm()
//       }
//     } catch (error) {}
//   }
//   return (
//     <Fragment>
//       <Wrapper>
//         <Formik
//           initialValues={initialValues}
//           onSubmit={handleSubmit}
//           enableReinitialize
//         >
//           {({ resetForm }) => (
//             <Form>
//               <div
//                 style={{
//                   display: 'flex',
//                   alignItems: 'flex-start',
//                   gap: '20px',
//                 }}
//               >
//                 <Grid
//                   repeat={1}
//                   styleGrid={`
//                     width: 200%;
//                   `}
//                 >
//                   <Fields.Input
//                     name="link"
//                     label="Redirect Link"
//                     placeholder="Type here"
//                   />
//                 </Grid>

//                 <Fields.Upload name="image" variant="banner" />
//               </div>

//               <Row styleRow="justify-content:flex-end; margin-top:20px; gap: 12px;">
//                 <Button
//                   type="button"
//                   title="Reset"
//                   height={45}
//                   width={100}
//                   styleButton={outlineButton}
//                   onClick={() => resetForm()}
//                 />
//                 <Button
//                   title={!state ? 'Submit' : 'Update'}
//                   height={45}
//                   width={100}
//                   type="submit"
//                 />
//                 {!!state && (
//                   <Button
//                     title={'cancel'}
//                     height={45}
//                     width={100}
//                     type="submit"
//                     styleButton="background:red"
//                     onClick={() => {
//                       navigate('/admin/banner-settings', { state: null })
//                     }}
//                   />
//                 )}
//               </Row>
//             </Form>
//           )}
//         </Formik>
//       </Wrapper>
//     </Fragment>
//   )
// }

// export default BannerForm

import { Banner } from '@apis/index'
import Button from '@components/button'
import Fields from '@components/fields'
import Grid from '@components/grid'
import Row from '@components/row'
import Wrapper from '@components/wrapper'
import { outlineButton } from '@pages/admin/payment/settings/form'
import { RootState } from '@store/index'
import { Form, Formik } from 'formik'
import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

const BannerForm = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const [initialValues, setInitialValues] = useState({
    link: '',
    image: '',
  })

  useEffect(() => {
    if (!!state) {
      setInitialValues({
        link: state.link,
        image: state.image,
      })
    } else {
      setInitialValues({
        link: '',
        image: '',
      })
    }
  }, [state])

  const handleSubmit = async (values, { resetForm }) => {
    try {
      const payload = {
        link: values.link,
        image:
          typeof values.image === 'string'
            ? values.image
            : {
                extension: values.image.extension,
                base64: values.image.base64,
              },
      }
      if (!!state) {
        await Banner.update({
          state: 'banners',
          id: state.id,
          data: JSON.stringify(payload),
        })
        navigate('/admin/banner-settings', { state: null })
        resetForm()
      } else {
        await Banner.create({
          state: 'banners',
          data: JSON.stringify(payload),
        })
        resetForm()
      }
    } catch (error) {}
  }

  return (
    <Fragment>
      <Wrapper>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          enableReinitialize
        >
          {({ resetForm }) => (
            <Form>
              <div
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '20px',
                  alignItems: 'flex-start',
                }}
              >
                <div
                  style={{
                    flex: '1 1 100%',
                    maxWidth: '100%',
                    minWidth: 0,
                  }}
                >
                  <Fields.Input
                    name="link"
                    label="Redirect Link"
                    placeholder="Type here"
                  />
                </div>

                <div
                  style={{
                    flex: '1 1 100%',
                    maxWidth: '100%',
                    minWidth: 0,
                  }}
                >
                  <Fields.Upload name="image" variant="banner" />
                </div>
              </div>

              <Row
                styleRow={`
                  justify-content:flex-end;
                  margin-top:20px;
                  gap: 12px;
                  flex-wrap: wrap;
                `}
              >
                <Button
                  type="button"
                  title="Reset"
                  height={45}
                  width={100}
                  styleButton={outlineButton}
                  onClick={() => resetForm()}
                />
                <Button
                  title={!state ? 'Submit' : 'Update'}
                  height={45}
                  width={100}
                  type="submit"
                />
                {!!state && (
                  <Button
                    title={'Cancel'}
                    height={45}
                    width={100}
                    type="submit"
                    styleButton="background:red"
                    onClick={() => {
                      navigate('/admin/banner-settings', { state: null })
                    }}
                  />
                )}
              </Row>
            </Form>
          )}
        </Formik>
      </Wrapper>
    </Fragment>
  )
}

export default BannerForm
